export default class ContractInvoiceEditCtrl {
    constructor($scope, $uibModalInstance, httpRequest, contractInvoice, logger, formvalidateApi) {
        $scope.contractInvoice = contractInvoice
        $scope.pageInfo = {}
        const userInfo = JSON.parse(localStorage.getItem('user_info'))
        // 有invoiceId 表示编辑 没有则手工录入
        if (contractInvoice.invoiceId) {
            $scope.pageInfo.title = '编辑发票'
        } else {
            $scope.pageInfo.title = '手工录入'
            $scope.contractInvoice.custCreditCode = userInfo.sale.saleCreditCode
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
        // 有invoiceId 表示编辑 没有则手工录入
        $scope.saveInvoice = function saveInvoice(isContinue) {
            if (!formvalidateApi.run()) {
                return
            }
            if (contractInvoice.invoiceId) {
                httpRequest.post_updateInvoice($scope.contractInvoice).then(() => {
                    logger.logSuccess('修改成功')
                    $uibModalInstance.close()
                })
            } else {
                const param = {
                    ...$scope.contractInvoice,
                    sourceIdentityId: $scope.contractInvoice.contractId,
                    invoiceSource: '1',
                    creditCode: $scope.contractInvoice.custCreditCode,
                    dataSource: '2',
                }
                httpRequest.post_saveInputInvoice(param).then(() => {
                    logger.logSuccess('录入成功')
                    if (isContinue) {
                        $scope.contractInvoice = {
                            contractId: $scope.contractInvoice.contractId,
                            custCreditCode: userInfo.sale.saleCreditCode,
                        }
                    } else {
                        $uibModalInstance.close()
                    }
                })
            }
        }
    }
}
ContractInvoiceEditCtrl.$inject = ['$scope', '$uibModalInstance', 'httpRequest', 'contractInvoice', 'logger', 'formvalidateApi']



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractManagement/contractInvoiceEditCtrl.js